import { useContext, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import Questionary from "../../Questionaries/Questionary/Questionary";
import Container from "../../../ui/Container/Container";
import { sendEmail, storeAdverseReactions } from "../../../db/users";
import { getReceiversEmail } from "../../../util/email";

function AdverseReactions() {
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const doctor = location.state.doctor;
  const clinicalInfo = location.state.clinicalInfo;
  const patientId = location.state.patientId;
  const [isLoading, setIsLoading] = useState(false);

  async function generateEmail(userAnswers) {
    setIsLoading(true);
    let html = `<p style="font-weight: bold">Datos del notificador</p>
    <p>Nombre: ${doctor.name} ${doctor.lastName} ${doctor.surName}</p>
    <p>Ocupación: ${doctor.speciality}</p>
    <p>Correo electrónico: ${doctor.email}</p>
    <p>Teléfono: ${doctor.cellPhone}</p>
    <p style="font-weight: bold">Datos del paciente</p>`;
    html += `<p>Nombre: ${clinicalInfo.patientName}</p>`;
    html += `<p style="font-weight: bold">Narración de SRAM</p>`;
    html += `<p>Nombre distintivo: Sienna SPM´s</p>`;
    html += `<p>Nombre genérico: SPM´s (17-HDHA, 18-HEPE y 14-HDHA), Ácidos grasos Omega 3 (EPA y DHA), Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina</p>`;
    userAnswers.forEach((answer) => {
      html += `<p>${answer.question} ${answer.answer}</p>`;
    });
    const subject = "ATRARE ADR SIENNA EAS";
    const receivers = getReceiversEmail(process.env.REACT_APP_EAS_RECEIVERS);
    await sendEmail(subject, html, receivers);
    await saveAdverseReactions(userAnswers);
    setIsLoading(false);
    alert("Reporte de reacciones adversas enviado con éxito.");
    navigate("/patientInfo", { state: { patientKey: patientId } });
  }

  async function saveAdverseReactions(userAnswers) {
    const eventElement = {
      doctorName: `${doctor.name} ${doctor.lastName} ${doctor.surName}`,
      doctorEmail: doctor.email,
      doctorCel: doctor.cellPhone,
      patientName: clinicalInfo.patientName,
      answers: userAnswers,
    };
    storeAdverseReactions(eventElement, authCtx.token);
  }

  if (isLoading){
    return (<p>Cargando...</p>)
  }

  return (
    <Container
      title={"Reacciones adversas"}
      backNavigation="/patientInfo"
      route={{ patientKey: patientId }}
    >
      <Questionary
        questionaryId={"adverse_reactions"}
        token={authCtx.token}
        onSaveQuestionary={generateEmail}
      />
    </Container>
  );
}

export default AdverseReactions;
